import { ObservableArray, View } from "binder"
import { ReceiptBillListViewModel, row } from "./receiptBillList-viewModel"
import { WarehouseSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ReceiptBillListView extends View<ReceiptBillListViewModel>{
    GetViewUniqueId(): string {
        return "V-584A16BD-6923-4F1F-829E-AE3E40F00667"
    }
    loadHtml(): string {
        let element = require('./receiptBillList.html').default;
        let style = require('./receiptBillList.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set rows(v: ObservableArray<row>) { this._rows = v; } public get rows(): ObservableArray<row> { return this._rows;} private _rows: ObservableArray<row>;
    public set filterDayFrom(v: moment.Moment) { this._filterDayFrom = v; } public get filterDayFrom(): moment.Moment { return this._filterDayFrom;} private _filterDayFrom: moment.Moment;
    public set filterDayTo(v: moment.Moment) { this._filterDayTo = v; } public get filterDayTo(): moment.Moment { return this._filterDayTo;} private _filterDayTo: moment.Moment;
    public set filterBillCode(v: string) { this._filterBillCode = v; } public get filterBillCode(): string { return this._filterBillCode;} private _filterBillCode: string;
    public set warehouseSelector(v: WarehouseSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelectorViewModel;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    refresh(){
        this.dataContext.refresh();
    }

    setAutomatic(){
        this.dataContext.setAutomatic();
    }
}
